export default __webpack_public_path__ + "images/peeclampsia_blue.af7ba0403d405f6feb3af5b3249d192e.png";